import { ModuloMenuSistemaEnum } from '../../enum/modulo-menu-sistema-enum';
import { UsuarioPerfilMenuResponse } from '../../response/usuario-perfil/usuario-perfil-menu-response';

export class BpMenuSistemaModel {
  id: ModuloMenuSistemaEnum;
  titulo: string;
  collapsed: boolean;
  icon: string;
  subMenus: UsuarioPerfilMenuResponse[];

  constructor(
    id?: ModuloMenuSistemaEnum,
    titulo?: string,
    collapsed?: boolean,
    icon?: string,
    subMenus?: UsuarioPerfilMenuResponse[]
  ) {
    this.id = id;
    this.titulo = titulo;
    this.collapsed = collapsed;
    this.icon = icon;
    this.subMenus = subMenus;
  }
}
